import { render, staticRenderFns } from "./consult-info19.vue?vue&type=template&id=1fcbb898&scoped=true"
import script from "./consult-info19.vue?vue&type=script&lang=js"
export * from "./consult-info19.vue?vue&type=script&lang=js"
import style0 from "./consult-info19.vue?vue&type=style&index=0&id=1fcbb898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcbb898",
  null
  
)

export default component.exports